export default __webpack_public_path__ + "static/media/404.d85333a7.jpg";